import {ICloseConfig, ICloseModal, IUpdateModal, IUpdateQrModal} from './types/modal.actions.types';

export const CLOSE_CONFIG = 'CLOSE_CONFIG';
export const UPDATE_MODAL = 'UPDATE MODAL';
export const CLOSE_MODAL = 'CLOSE__MODAL';
export const UPDATE_PRESENTATION_QR_MODAL = 'UPDATE_PRESENTATION_QR_MODAL';

export const closeConfig = (): ICloseConfig => ({
    type: CLOSE_CONFIG,
});

export const updateModal = (modalVisible: boolean, slideId: string, clickToDisplay: string[]): IUpdateModal => ({
    type: UPDATE_MODAL,
    payload: {
        modalVisible,
        slideId,
        clickToDisplay,
    },
});

export const updateQrModal = (isVisible: boolean): IUpdateQrModal => ({
    type: UPDATE_PRESENTATION_QR_MODAL,
    payload: isVisible,
});

export const closeModalAction = (): ICloseModal => ({
    type: CLOSE_MODAL,
});
